import React from "react";
const Breadcrumb = ({ parent, child }) => {
  return (
    <div className="content-header">
      <div className="breadcrumb-main">
        <div className="row">
          <div className="col-6">
            <div className="breadcrumb-title">
              <h4 className="page-title">{child}</h4>
            </div>
          </div>
          <div className="col-6">
            <ul className="breadcrumb-list">
              <li className="breadcrumb-item bcrumb-1">
                <a href="/">
                  <div className="breadcrumb-icon">
                    <i className=" feather fa-regular fa-house fa-lg"></i>
                  </div>
                </a>
              </li>
              <li className="breadcrumb-item ng-star-inserted">{parent}</li>
              {child && <li className="breadcrumb-item active">{child}</li>}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Breadcrumb;
